import * as THREE from '/src/assets/scripts/libs/three-r97/three.module';
import OBJLoader from './OBJLoader';

let OBMLoader;

(function(k) {
    let m;
    function r(f, p) {
        var e = new k.Vector3(),
            c = new k.Vector3(),
            d = new k.Vector3(),
            a = new k.Vector3(),
            g = new k.Vector3(),
            n = p.vertices[f.a],
            h = p.vertices[f.b],
            m = p.vertices[f.c];
        if (f instanceof k.Face3) return e.subVectors(m, h), c.subVectors(n, h), e.cross(c), e;
        if (f instanceof k.Face4) return (e = p.vertices[f.d]), d.subVectors(e, h), c.subVectors(n, h), d.cross(c), a.subVectors(e, m), g.subVectors(h, m), a.cross(g), a.add(d), a.multiplyScalar(0.5);
    }
    OBMLoader = function(f) {
        OBJLoader.call(this, f);
    };
    OBMLoader.prototype = Object.create(OBJLoader.prototype);
    OBMLoader.prototype.load = function(f, p, e, c) {
        var d = this,
            a = new k.FileLoader(d.manager);
        a.setPath(this.path);
        a.load(
            f,
            function (a) {
                d.loadString(a, p);
            },
            e,
            c
        );
    };
    OBMLoader.prototype.loadString = function(f, p) {
        f = this.preprocess(f);
        var e = this.parse(f);
        m.vn_autocreate &&
        e.children.forEach(function (c, d) {
            c.geometry = new k.Geometry().fromBufferGeometry(c.geometry);
            c.geometry.mergeVertices();
            c.geometry.computeVertexNormals();
            c.geometry = new k.BufferGeometry().fromGeometry(c.geometry);
        });
        m.vn_autocreate_degrees &&
        e.children.forEach(function (c, d) {
            c.geometry = new k.Geometry().fromBufferGeometry(c.geometry);
            c.geometry.mergeVertices();
            c.geometry.computeVertexNormalsByDegrees(m.vn_autocreate_degrees);
            c.geometry = new k.BufferGeometry().fromGeometry(c.geometry);
        });
        p(e);
    };
    OBMLoader.prototype.preprocess = function(f) {
        f = f.replace(/~/g, "//").split("\n");
        for (var k = [0, 0, 0], e = [0, 0, 0], c = [0, 0], d, a, g, n, h = 0, t = f.length; h < t; h++) {
            var b = f[h].trim().split(" "),
                l = b.shift();
            if ("v" === l) (b[0] = k[0] + parseInt(b[0], 10) / a), (b[1] = k[1] + parseInt(b[1], 10) / a), (b[2] = k[2] + parseInt(b[2], 10) / a), (f[h] = "v " + b[0] * m.scale + " " + b[1] * m.scale + " " + b[2] * m.scale), (k = b);
            else if ("vn" === l) (b[0] = e[0] + parseFloat(b[0]) / n), (b[1] = e[1] + parseFloat(b[1]) / n), (b[2] = e[2] + parseFloat(b[2]) / n), (f[h] = "vn " + b[0] + " " + b[1] + " " + b[2]), (e = b);
            else if ("vt" === l) "undefined" !== typeof c && ((b[0] = c[0] + parseFloat(b[0]) / g), (b[1] = c[1] + parseFloat(b[1]) / g), (b[2] = c[2] + parseFloat(b[2]) / g), (f[h] = "vt " + b[0] + " " + b[1] + " " + b[2])), (c = b);
            else if ("f" === l) {
                b = b.map(function (a) {
                    return a.split("/");
                });
                if ("undefined" === typeof d) for (d = b.slice(0), l = 0; l < b.length; l++) b[l] = b[l].join("/");
                else {
                    for (var l = 0, r = b.length; l < r; l++) for (var q = 0, u = b[l].length; q < u; q++) d[l] && b[l] && "" !== b[l][q] && (b[l][q] = parseInt(b[l][q], 10) + parseInt(d[l][q], 10));
                    d = b.slice(0);
                    for (l = 0; l < r; l++) b[l] = b[l].join("/");
                }
                f[h] = "f " + b.join(" ");
            } else "#" === l && "INSTRUCTIONS" === b[0] && ((m = JSON.parse(b.slice(1).join(" "))), (a = Math.pow(10, m.v_precision)), (g = Math.pow(10, m.vt_precision)), (n = Math.pow(10, m.vn_precision)));
        }
        return f.join("\n");
    };
    k.Geometry.prototype.computeVertexNormalsByDegrees = function(f) {
        for (var m = this.faces, e = this.vertices, c = Array(e.length), d = m.length; d--; ) {
            var a = m[d],
                g = a.normal.length(),
                n = a.vertexNormals;
            c[a.a] = c[a.a] || [];
            c[a.a].push({ face: a, face_normal_length: g, vertexNormal: n[0], smoothingGroup: [] });
            c[a.b] = c[a.b] || [];
            c[a.b].push({ face: a, face_normal_length: g, vertexNormal: n[1], smoothingGroup: [] });
            c[a.c] = c[a.c] || [];
            c[a.c].push({ face: a, face_normal_length: g, vertexNormal: n[2], smoothingGroup: [] });
            a.d && ((c[a.d] = c[a.d] || []), c[a.d].push({ face: a, face_normal_length: g, vertexNormal: n[3], smoothingGroup: [] }));
        }
        for (var h, d = 0, e = e.length; e--; ) {
            if (c[e])
                for (var a = 0, i_length = c[e].length; a < i_length; a++) {
                    var g = c[e][a],
                        n = c[e][(a + 1) % c[e].length],
                        t = g.face.normal.dot(n.face.normal);
                    (180 * Math.acos(t / (g.face_normal_length * n.face_normal_length))) / Math.PI <= f
                        ? ((h = !0), g.smoothingGroup.push(d), n.smoothingGroup.push(d))
                        : (d++, g.vertexNormal.add(c[e][a].face.normal), n.vertexNormal.add(n.face.normal));
                }
            if (h) {
                d = c[e];
                h = {};
                for (g = d.length; g--; ) (a = d[g].smoothingGroup[0]), h[a] ? h[a].averageVec.add(r(d[g].face, this)) : (h[a] = { averageVec: r(d[g].face, this) });
                2 === d[0].smoothingGroup.length && ((a = h[d[0].smoothingGroup[0]]), (d = h[d[0].smoothingGroup[1]]), (g = new k.Vector3().addVectors(a.averageVec, d.averageVec)), (a.averageVec = g), (d.averageVec = g));
                a = h;
                for (g = c[e].length; g--; ) (h = c[e][g]), (d = h.smoothingGroup[0]), void 0 !== d && h.vertexNormal.copy(a[d].averageVec);
            }
            h = !1;
            d = 0;
        }
        for (a = m.length; a--; ) for (f = m[a].vertexNormals.length; f--; ) m[a].vertexNormals[f].normalize();
    };
})(THREE);

export default OBMLoader;